module.exports = {
  homePage: {
    section0: 'DIGITAL PROJECTS',
    section1: 'DESIGN MANAGEMENT<br/>PROJECT MANAGEMENT<br/>PROJECT CONTROLS<br/>PROGRAMME MANAGEMENT',
    section2: 'QUANTITY SURVEYING & COST MANAGEMENT<br/>PROCUREMENT & CONTRAT SERVICES<br/>VALUE ENGINEERING ANALYSIS<br/>TECHNICAL DUE DELIGENCE',
    section3: 'MARKET & FEASIBILITY STUDY<br/>SITE SECLECTION & LAND ACQUISTION <br/>AUTHORITY PERMIT & APPROVALS<br/>PROJECT DIAGNOSIS ADVISORY',
    section4: 'BIM & BIM⁺ SERVICES （3D/4D/5D/6D/ETC.）<br/>BIM IMPLEMENTATION PLANNING<br/>BIM PROJECT MANAGEMENT<br/>BIM TRAINING ',
    section5: 'DESIGN MANAGEMENT<br/>PROJECT MANAGEMENT<br/>PROJECT CONTROLS<br/>PROGRAMME MANAGEMENT',
    section6: 'ABOUT',
    section7: 'SERVICE',
    section8: 'PROJECTS',
    section9: 'CONTACT',
    sloganTitle: 'STRIVING FOR EXCELLENCE, WITH COMPLIANCE',
    sloganContent: 'DIGITAL PROJECTS<br/> IS<br/> A BOUTIQUE CONSULTANCY AND, A BIM & BIM⁺ TECHNOLOGY SERVICE PROVIDER THROUGHOUT PROJECT LIFECYCLE IN THE INDUSTRY OF CHINA.'
  },
  about: {
    title: 'ABOUT',
    content0: 'DIGITAL PROJECTS IS A BOTIQUE CONSULTANCY SPECIALIZED IN PROJECT MENEGEMNET FOR DEVELOPMENT AND CONSTRUCTION PROJECTS, WHICH WAS FOUNDED BY OVERSEAS-RETURNEES WITH TOP EDUCATION BACKGROUNDS AND DECADES OF INDUSTRIAL EXPERIENCES IN CHINA, UK, AND US. OUR CORE TEAM MEMBERS\' TRACK RECORDS COVER A FULL SPECTRUM OF DEVELOPMENT AND CONSTRUCTION PROJECTS. ',
    content1: 'WE ARE DETERMINED TO DELIVER PROJECTS AND SOLUTIONS WITH APPROACHES OF THE HIGHEST STANDARDS. DIGITAL TECHNOLOGIES, SUCH AS BIM & BIM⁺, ARE LEVERAGED TO DELIVER HIGH QUALITY SERVICES PER OUR CLIENTS\' REQUIREMENTS THROUGHOUT PLANNING, DESIGN, PROCUREMENT, CONSTRUCTION, AND FACILITY OPERATIONS PHASES. \n' +
    '\n'
  },
  service: {
    title: 'SERVICE',
    t0: '',
    t1: '',
    t2: '',
    t3: '',
    t4: '',
    t5: '',
    t6: '',
    t7: '',
    t8: '',
    t9: ''
  },
  project: {
    title: 'PROJECTS'
  },
  contact: {
    title: 'CONTACT',
    content0: 'INFO@DIGIPROS-PM.COM, DIGITALPROJECTS@DIGIPROS-PM.COM<br/>F1, BUILDING 5, 20 CHALING (N) ROAD, SHANGHAI 200032, CHINA'
  },
  footer: {
    name: '© 2016 - 2018 BY DIGITAL PROJECTS<br/>© 2016 - 2018 BY嘉黍工程管理咨询有限公司',
    contact: 'DIGITAL PROJECTS F1, BUILDING 5, 20 CHALING (N) ROAD, SHANGHAI 200032, CHINA<br/>CONTACT: INFO@DIGIPROS-PM.COM, DIGITALPROJECTS@DIGIPROS-PM.COM'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js